module.exports = __webpack_public_path__ + "static/media/close-icon-vm.f320d51b.svg";